import { HSLColor } from '@yola/yola-palette-generator';

const secondaryButtonLightGrayHover = ({ targetColor }) => {
  const { hue, saturation, lightness, alpha } = targetColor;
  const colorInstance = new HSLColor(hue, saturation, lightness, alpha);
  const defaultAlpha = colorInstance.getAlpha();

  const newAlpha = defaultAlpha < 1 ? defaultAlpha / 2 : 0.4;

  colorInstance.setAlpha(newAlpha);
  return colorInstance;
};

export default secondaryButtonLightGrayHover;
